/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import "./Referral.scss";
import Gify from "../../images/ReferralGIF.gif";
import Popover from "@mui/material/Popover";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import notify from "../../components/CustomUseNotify";
import { useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import { createTheme, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const customTheme = createTheme({});

const Referral = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [startFromPage1, setStartFromPage1] = useState(false);
  const location = useLocation();
  const isSmallDevice = useMediaQuery((theme) =>
    customTheme.breakpoints.down("sm")
  );

  //State for form data
  const [siteName, setSiteName] = useState("");
  const [siteAddress, setSiteAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [sitePersonName, setSitePersonName] = useState("");
  const [sitePersonNumber, setSitePersonNumber] = useState("");
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [email, setEmail] = useState("");
  const [referralId, setReferralId] = useState("");


  const openDialogHandler = () => {
    setStartFromPage1(true);
    setPage(1);
    setOpenDialog(true);
  };

  const closeDialogHandler = () => {
    setOpenDialog(false);
    setPage(0);
    // Clear the form fields by resetting all state variables to their initial values
    setSiteName("");
    setSiteAddress("");
    setPincode("");
    setCity("");
    setState("");
    setSitePersonName("");
    setSitePersonNumber("");
    setName("");
    setNumber("");
    setEmail("");
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const handlePincodeChange = async () => {
    try {
      if (!pincode) {
        // Handle the case where the pincode is not provided.
        return;
      }

      const response = await fetch(
        `https://parksmart.co.in/website/pincodeDetails?pincode=${pincode}`
      );

      if (!response.ok) {
        // Handle the case where the fetch request was not successful.
        notify(`Fetch request failed with status ${response.status}`);
      }

      const json = await response.json();

      if (json.data && json.data.length > 0) {
        setCity(json.data[0].District);
        setState(json.data[0].State);
      } else {
        setCity("");
        setState("");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  function handlePageToOne() {
    setPage(1);
  }

  const handlePageToTwo = (event) => {
    event.preventDefault();

    // Validation checks
    if (!siteName || !siteAddress) {
      toast.success("Please fill in all required fields.", {
        type: "warning",
        theme: "colored",
        style: {
          zIndex: 1301,
        },
        zIndex: 1301,
      });
      return;
    }

    if (pincode.length !== 6) {
      toast.success("Pincode must be of 6 digits.", {
        type: "warning",
        theme: "colored",
      });
      return;
    }

    if (!city || !state) {
      toast.success("Please enter a valid pincode.", {
        type: "warning",
        theme: "colored",
      });
      return;
    }
    try {
      fetch(`https://parksmart.in/website/referParkingSite`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          site_name: siteName,
          site_address: siteAddress,
          site_pincode: pincode,
          site_city: city,
          site_state: state,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            notify("Network response was not ok");
          }
          return response.json();
        })
        .then((json) => {
          // console.log(json.referralId);
          // Proceed to the next page if validations pass
          if (!json.success) {
            toast.success(json.message, {
              type: "warning",
              theme: "colored",
            });
            return;
          }
          setReferralId(json.referralId);
          setPage(2);
        })
        .catch((error) => {
          notify("Something went wrong", "warning");
        });
    } catch (error) {
      notify("An error occurred while processing your request", "error");
    }
  };
  function handleApply(event) {
    event.preventDefault();
    if (!sitePersonName || !sitePersonNumber || !name || !number || !email) {
      toast.success("Please fill in all required fields.", {
        type: "warning",
        theme: "colored",
      });
      return;
    }
    if (
      !new RegExp("^[0-9]{10}$").test(number) ||
      !new RegExp("^[0-9]{10}$").test(sitePersonNumber)
    ) {
      toast.success("Phone Number must be 10 digits.", {
        type: "warning",
        theme: "colored",
      });
      return;
    }
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!emailPattern.test(email)) {
      toast.success("Please enter a valid email address.", {
        type: "warning",
        theme: "colored",
      });
      return;
    }

    try {
      fetch(`https://parksmart.in/website/referParkingSite`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: referralId,
          site_name: siteName,
          site_address: siteAddress,
          site_pincode: pincode,
          site_city: city,
          site_state: state,
          spoc_name: sitePersonName,
          spoc_mobile_number: sitePersonNumber,
          referrer_name: name,
          referrer_mobile_number: number,
          referrer_email: email,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            notify("Network response was not ok");
          }
          return response.json();
        })
        .then((json) => {
          console.log(json);
          // Proceed to the next page if validations pass
          if (!json.success) {
            toast.success(json.message, {
              type: "warning",
              theme: "colored",
            });
            return;
          }
          toast.success("Thank you for referring", {
            type: "success",
            theme: "colored",
          });
          closeDialogHandler();
        })
        .catch((error) => {
          notify("Something went wrong", "warning");
        });
    } catch (error) {
      notify("An error occurred while processing your request", "error");
    }
  }

  useEffect(() => {
    handlePincodeChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pincode]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const aidParam = searchParams.get("aid");

    // Check if the "aid" parameter is present and set the startFromPage1 state accordingly
    if (aidParam === "referral") {
      setOpenDialog(true);
      setStartFromPage1(false); // Don't start from page 1
    } else {
      setStartFromPage1(true); // Start from page 1
    }
  }, [location.search]);

  useEffect(() => {
    const timer = setTimeout(() => {
      console.log("Popup timer expired");
      setOpenDialog(true);
      setStartFromPage1(false);
    }, 5000);
  
    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="referral">
      <div className="referral-section">
        <div className="heading-section">
          <p className="earn-section">Earn</p>
          <p className="money-section">
            <span>&#x20b9;</span>10,000
          </p>
        </div>
        <div>
          <p className="sub-section">Refer your Society and IT Park</p>
        </div>
        <div className="summary-section">
          Refer residential societies or IT parks to ParkSmart, share site
          details, and receive regular updates. On successful conversions, enjoy
          an exciting bonus of{" "}
          <span style={{ fontWeight: "bold" }}>₹10,000</span>. Join us in
          automate your gates for authorised vehicles, and reap the benefits
          with ParkSmart Referral Program. Refer us today!
        </div>
        <div className="button-section">
          <button className="button" onClick={openDialogHandler}>
            Refer Now
          </button>
        </div>
      </div>
      <div className="gif-section">
        <img className="gify" src={Gify} alt="" />
      </div>

      {/* Popover */}

      <div className="popover-section">
        <Dialog
          open={openDialog}
          onClose={closeDialog}
          PaperProps={{
            style: {
              borderRadius: isSmallDevice ? "" : "15px", // Add a 10px border radius to the dialog
              width: isSmallDevice ? "100vw" : "",
              height: isSmallDevice ? "100vh" : "",
              margin: "0", // Remove any margins
              overflow:"scroll"
            },
          }}
        >
          {startFromPage1 ? (
            <div>
              {page === 1 && (
                <div
                  className="referral-site"
                >
                    <div className="heading-site">
                      <p className="heading">Refer and Earn</p>
                      {isSmallDevice &&<button style={{background: "none", border:"none", marginLeft:60}} onClick={closeDialog}><CloseIcon style={{fontSize:"30",color: "#334d6e"}}/></button>}
                    </div>
                  <div>
                    <div className="gify-section-site">
                      <div className="main-content-site">
                        <div className="heading-section-site">
                          <p className="earn-section-site">
                            Earn{" "}
                            <span style={{ color: "#18cc69" }}>
                              <span>&#x20b9;</span>10,000
                            </span>
                          </p>
                        </div>
                        <div>
                          <p className="sub-section-site">
                            Refer your Society and IT Park
                          </p>
                        </div>
                      </div>
                      <div className="gif-section-site">
                        <img className="gify-site" src={Gify} alt="" />
                      </div>
                    </div>
                    <div className="form-site">
                      <form className="form-container">
                        <div class="formbold-main-wrapper">
                          <div class="formbold-form-wrapper">
                            <label
                              class="formbold-form-label formbold-form-label-2"
                              style={{ color: "#334D6E" }}
                            >
                              Site Details
                            </label>
                            <div
                              class="formbold-mb-5"
                              style={{ marginTop: 10 }}
                            >
                              <label for="name" class="formbold-form-label">
                                {" "}
                                Site Name*{" "}
                              </label>
                              <input
                                type="text"
                                name="name"
                                id="name"
                                class="formbold-form-input"
                                required
                                value={siteName}
                                onChange={(event) =>
                                  setSiteName(event.target.value)
                                }
                              />
                            </div>
                            <div class="formbold-mb-5">
                              <label for="address" class="formbold-form-label">
                                {" "}
                                Site Address*{" "}
                              </label>
                              <input
                                type="text"
                                name="address"
                                id="address"
                                class="formbold-form-input"
                                required
                                value={siteAddress}
                                onChange={(event) =>
                                  setSiteAddress(event.target.value)
                                }
                              />
                            </div>
                            <div class="formbold-mb-5">
                              <label for="pincode" class="formbold-form-label">
                                {" "}
                                Pincode*{" "}
                              </label>
                              <input
                                name="pincode"
                                id="pincode"
                                class="formbold-form-input"
                                required
                                maxLength={6}
                                pattern="[0-9]*" // Use [0-9]* pattern to allow only numbers
                                value={pincode}
                                onChange={(event) => {
                                  const input = event.target.value;
                                  const numbersOnly = input.replace(/\D/g, ""); // Remove non-numeric characters
                                  setPincode(numbersOnly);
                                }}
                              />
                            </div>
                            <div class="flex flex-wrap formbold--mx-3">
                              <div class="w-full sm:w-half formbold-px-3">
                                <div class="formbold-mb-5 w-full">
                                  <label for="city" class="formbold-form-label">
                                    {" "}
                                    City{" "}
                                  </label>
                                  <input
                                    type="text"
                                    name="city"
                                    id="city"
                                    label="Pin Code"
                                    class="formbold-form-input"
                                    disabled
                                    value={city}
                                  />
                                </div>
                              </div>
                              <div class="w-full sm:w-half formbold-px-3">
                                <div class="formbold-mb-5">
                                  <label
                                    for="state"
                                    class="formbold-form-label"
                                  >
                                    {" "}
                                    State{" "}
                                  </label>
                                  <input
                                    type="text"
                                    name="state"
                                    id="state"
                                    class="formbold-form-input"
                                    disabled
                                    value={state}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="button-section-site">
                          <button
                            className="button-site"
                            type="submit"
                            onClick={handlePageToTwo}
                          >
                            Next
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
              {page === 2 && (
                <div className="referral-site">
                  <div className="heading-site">
                    <button
                      onClick={handlePageToOne}
                      style={{
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        color: "#334D6E",
                      }}
                    >
                      <ArrowBackIcon style={{ fontSize: 30, marginTop:2 }} />
                    </button>
                    <p className="heading-site-earn" style={{ marginLeft: 10 }}>
                      Refer and Earn
                    </p>
                    {isSmallDevice &&<button style={{background: "none", border:"none", marginLeft:90}} onClick={closeDialog}><CloseIcon style={{fontSize:"30",color: "#334d6e"}}/></button>}
                  </div>
                  <div>
                    <div className="form-site-refer-earn">
                      <form className="form-container">
                        <div class="formbold-main-wrapper">
                          <div class="formbold-form-wrapper">
                            <label
                              class="formbold-form-label formbold-form-label-2"
                              style={{ color: "#334D6E" }}
                            >
                              Site Contact Person
                            </label>
                            <div
                              class="formbold-mb-5"
                              style={{ marginTop: 10 }}
                            >
                              <label for="name" class="formbold-form-label">
                                {" "}
                                Contact Person Name*{" "}
                              </label>
                              <input
                                type="text"
                                name="name"
                                id="name"
                                class="formbold-form-label-personal-section"
                                required
                                value={sitePersonName}
                                onChange={(event) =>
                                  setSitePersonName(event.target.value)
                                }
                              />
                            </div>
                            <div class="formbold-mb-5">
                              <label for="email" class="formbold-form-label">
                                {" "}
                                Contact Person Number*{" "}
                              </label>
                              <input
                                name="pincode"
                                id="pincode"
                                class="formbold-form-input formbold-form-label-personal-section"
                                required
                                maxLength={10}
                                pattern="[0-9]*" // Use [0-9]* pattern to allow only numbers
                                value={sitePersonNumber}
                                onChange={(event) => {
                                  const input = event.target.value;
                                  const numbersOnly = input.replace(/\D/g, ""); // Remove non-numeric characters
                                  setSitePersonNumber(numbersOnly);
                                }}
                              />
                            </div>
                            <label
                              class="formbold-form-label formbold-form-label-2"
                              style={{ color: "#334D6E", marginBottom: 5 }}
                            >
                              Your Details
                            </label>
                            <div class="formbold-mb-5">
                              <label for="email" class="formbold-form-label">
                                {" "}
                                Your Name*{" "}
                              </label>
                              <input
                                type="text"
                                name="name"
                                id="yourname"
                                class="formbold-form-label-personal-section"
                                required
                                value={name}
                                onChange={(event) =>
                                  setName(event.target.value)
                                }
                              />
                            </div>
                            <div class="formbold-mb-5">
                              <label for="email" class="formbold-form-label">
                                {" "}
                                Your Number*{" "}
                              </label>
                              <input
                                name="pincode"
                                id="pincode"
                                class="formbold-form-input formbold-form-label-personal-section"
                                required
                                maxLength={10}
                                pattern="[0-9]*" // Use [0-9]* pattern to allow only numbers
                                value={number}
                                onChange={(event) => {
                                  const input = event.target.value;
                                  const numbersOnly = input.replace(/\D/g, ""); // Remove non-numeric characters
                                  setNumber(numbersOnly);
                                }}
                              />
                            </div>
                            <div class="formbold-mb-5">
                              <label for="email" class="formbold-form-label">
                                {" "}
                                Your Email ID*{" "}
                              </label>
                              <input
                                type="email"
                                name="emailId"
                                id="youremailId"
                                class="formbold-form-label-personal-section"
                                required
                                value={email}
                                onChange={(event) =>
                                  setEmail(event.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="button-section-site">
                          <button className="button-site" onClick={handleApply}>
                            Apply
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div>
              {page === 0 && (
                <div className="referral-earn">
                  <div className="referral-section">
                    <div className="heading-section">
                      <p className="earn-section-earn">Refer & Earn</p>
                      <p className="money-section-earn">
                        <span>&#x20b9;</span>10,000
                      </p>
                      {isSmallDevice &&<button style={{background: "none", border:"none", marginLeft:60}} onClick={closeDialog}><CloseIcon style={{fontSize:"30",color: "#334d6e"}}/></button>}
                    </div>
                    <div className="gif-section-earn">
                      <img className="gify-earn" src={Gify} alt="" />
                    </div>
                    <div>
                      <p className="sub-section-earn">
                        Refer your Society and IT Park
                      </p>
                    </div>
                    <div className="summary-section-earn">
                      Refer residential societies or IT parks to ParkSmart,
                      share site details, and receive regular updates. On
                      successful conversions, enjoy an exciting bonus of{" "}
                      <span style={{ fontWeight: "bold" }}>₹10,000</span>. Join
                      us in automate your gates for authorised vehicles, and
                      reap the benefits with ParkSmart Referral Program. Refer
                      us today!
                    </div>
                    <div className="button-section-earn">
                      <button className="button-earn" onClick={handlePageToOne}>
                        Refer Now
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {page === 1 && (
                <div
                  className="referral-site"
                >
                    <div className="heading-site">
                      <p className="heading">Refer and Earn</p>
                      {isSmallDevice &&<button style={{background: "none", border:"none", marginLeft:80}} onClick={closeDialog}><CloseIcon style={{fontSize:"30",color: "#334d6e"}}/></button>}
                    </div>
                  <div>
                    <div className="gify-section-site">
                      <div className="main-content-site">
                        <div className="heading-section-site">
                          <p className="earn-section-site">
                            Earn{" "}
                            <span style={{ color: "#18cc69" }}>
                              <span>&#x20b9;</span>10,000
                            </span>
                          </p>
                        </div>
                        <div>
                          <p className="sub-section-site">
                            Refer your Society and IT Park
                          </p>
                        </div>
                      </div>
                      <div className="gif-section-site">
                        <img className="gify-site" src={Gify} alt="" />
                      </div>
                    </div>
                    <div className="form-site">
                      <form className="form-container">
                        <div class="formbold-main-wrapper">
                          <div class="formbold-form-wrapper">
                            <label
                              class="formbold-form-label formbold-form-label-2"
                              style={{ color: "#334D6E" }}
                            >
                              Site Details
                            </label>
                            <div
                              class="formbold-mb-5"
                              style={{ marginTop: 10 }}
                            >
                              <label for="name" class="formbold-form-label">
                                {" "}
                                Site Name*{" "}
                              </label>
                              <input
                                type="text"
                                name="name"
                                id="name"
                                class="formbold-form-input"
                                required
                                value={siteName}
                                onChange={(event) =>
                                  setSiteName(event.target.value)
                                }
                              />
                            </div>
                            <div class="formbold-mb-5">
                              <label for="address" class="formbold-form-label">
                                {" "}
                                Site Address*{" "}
                              </label>
                              <input
                                type="text"
                                name="address"
                                id="address"
                                class="formbold-form-input"
                                required
                                value={siteAddress}
                                onChange={(event) =>
                                  setSiteAddress(event.target.value)
                                }
                              />
                            </div>
                            <div class="formbold-mb-5">
                              <label for="pincode" class="formbold-form-label">
                                {" "}
                                Pincode*{" "}
                              </label>
                              <input
                                name="pincode"
                                id="pincode"
                                class="formbold-form-input"
                                required
                                maxLength={6}
                                pattern="[0-9]*" // Use [0-9]* pattern to allow only numbers
                                value={pincode}
                                onChange={(event) => {
                                  const input = event.target.value;
                                  const numbersOnly = input.replace(/\D/g, ""); // Remove non-numeric characters
                                  setPincode(numbersOnly);
                                }}
                              />
                            </div>
                            <div class="flex flex-wrap formbold--mx-3">
                              <div class="w-full sm:w-half formbold-px-3">
                                <div class="formbold-mb-5 w-full">
                                  <label for="city" class="formbold-form-label">
                                    {" "}
                                    City{" "}
                                  </label>
                                  <input
                                    type="text"
                                    name="city"
                                    id="city"
                                    label="Pin Code"
                                    class="formbold-form-input"
                                    disabled
                                    value={city}
                                  />
                                </div>
                              </div>
                              <div class="w-full sm:w-half formbold-px-3">
                                <div class="formbold-mb-5">
                                  <label
                                    for="state"
                                    class="formbold-form-label"
                                  >
                                    {" "}
                                    State{" "}
                                  </label>
                                  <input
                                    type="text"
                                    name="state"
                                    id="state"
                                    class="formbold-form-input"
                                    disabled
                                    value={state}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="button-section-site">
                          <button
                            className="button-site"
                            type="submit"
                            onClick={handlePageToTwo}
                          >
                            Next
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
              {page === 2 && (
                <div className="referral-site">
                  <div className="heading-site">
                    <button
                      onClick={handlePageToOne}
                      style={{
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        color: "#334D6E",
                      }}
                    >
                      <ArrowBackIcon style={{ fontSize: 30, marginTop:2 }} />
                    </button>
                    <p className="heading-site-earn" style={{ marginLeft: 10 }}>
                      Refer and Earn
                    </p>
                    {isSmallDevice &&<button style={{background: "none", border:"none", marginLeft:65}} onClick={closeDialog}><CloseIcon style={{fontSize:"30",color: "#334d6e"}}/></button>}
                  </div>
                  <div>
                    <div className="form-site-refer-earn">
                      <form className="form-container">
                        <div class="formbold-main-wrapper">
                          <div class="formbold-form-wrapper">
                            <label
                              class=" formbold-form-label-2"
                              style={{ color: "#334D6E" }}
                            >
                              Site Contact Person
                            </label>
                            <div
                              class="formbold-mb-5"
                              style={{ marginTop: 10 }}
                            >
                              <label for="name" class="formbold-form-label">
                                {" "}
                                Contact Person Name*{" "}
                              </label>
                              <input
                                type="text"
                                name="name"
                                id="name"
                                class="formbold-form-label-personal-section"
                                required
                                value={sitePersonName}
                                onChange={(event) =>
                                  setSitePersonName(event.target.value)
                                }
                              />
                            </div>
                            <div class="formbold-mb-5">
                              <label for="email" class="formbold-form-label">
                                {" "}
                                Contact Person Number*{" "}
                              </label>
                              <input
                                name="pincode"
                                id="pincode"
                                class="formbold-form-input formbold-form-label-personal-section"
                                required
                                maxLength={10}
                                pattern="[0-9]*" // Use [0-9]* pattern to allow only numbers
                                value={sitePersonNumber}
                                onChange={(event) => {
                                  const input = event.target.value;
                                  const numbersOnly = input.replace(/\D/g, ""); // Remove non-numeric characters
                                  setSitePersonNumber(numbersOnly);
                                }}
                              />
                            </div>
                            <label
                              class=" formbold-form-label-2"
                              style={{ color: "#334D6E", marginBottom: 5 }}
                            >
                              Your Details
                            </label>
                            <div class="formbold-mb-5">
                              <label for="email" class="formbold-form-label">
                                {" "}
                                Your Name*{" "}
                              </label>
                              <input
                                type="text"
                                name="name"
                                id="yourname"
                                class="formbold-form-label-personal-section"
                                required
                                value={name}
                                onChange={(event) =>
                                  setName(event.target.value)
                                }
                              />
                            </div>
                            <div class="formbold-mb-5">
                              <label for="email" class="formbold-form-label">
                                {" "}
                                Your Number*{" "}
                              </label>
                              <input
                                name="pincode"
                                id="pincode"
                                class="formbold-form-input formbold-form-label-personal-section"
                                required
                                maxLength={10}
                                pattern="[0-9]*" // Use [0-9]* pattern to allow only numbers
                                value={number}
                                onChange={(event) => {
                                  const input = event.target.value;
                                  const numbersOnly = input.replace(/\D/g, ""); // Remove non-numeric characters
                                  setNumber(numbersOnly);
                                }}
                              />
                            </div>
                            <div class="formbold-mb-5">
                              <label for="email" class="formbold-form-label">
                                {" "}
                                Your Email ID*{" "}
                              </label>
                              <input
                                type="email"
                                name="emailId"
                                id="youremailId"
                                class="formbold-form-label-personal-section"
                                required
                                value={email}
                                onChange={(event) =>
                                  setEmail(event.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="button-section-site">
                          <button className="button-site" onClick={handleApply}>
                            Apply
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </Dialog>
      </div>
    </div>
  );
};

export default Referral;
